// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-expansion-panel-content .v-text-field[data-v-5533d9f5],.v-expansion-panel-content .v-textarea[data-v-5533d9f5]{margin-bottom:4px!important}@media (max-width:780px){.v-btn[data-v-5533d9f5]{margin-top:10px!important;padding-top:10px!important}.v-text-field[data-v-5533d9f5],.v-textarea[data-v-5533d9f5]{width:100%!important;-webkit-box-flex:1;-ms-flex:1 1 100%;flex:1 1 100%;margin-bottom:10px!important}}", ""]);
// Exports
module.exports = exports;
